/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  ClaimLockPathParameters,
  CloneTouchpointPathParameters,
  CreateEmailTouchpointWithContentRequest,
  CreateNewDraftVersionPathParameters,
  CreateParentEmailPathParameters,
  CreateTouchpointVersionPathParameters,
  DeleteTouchpointVersionPathParameters,
  ExtractLinksFromFinalHtmlPathParameters,
  GenerateArchiveHtmlPathParameters,
  GetAllVersionsParams,
  GetAllVersionsPathParameters,
  GetOneVersionPathParameters,
  LinkDTO,
  PagedModelTouchpointVersionSummaryDTO,
  PatchTouchpointVersionPathParameters,
  ReleaseLockPathParameters,
  ServerSentEventClientStreamEventDTO,
  TouchpointVersionCloneRequest,
  TouchpointVersionCreateRequest,
  TouchpointVersionDTO,
  TouchpointVersionPatchRequest,
  TransformEmailAsyncPathParameters,
  TransformEmailPathParameters,
  TransformEmailRequest,
  UpdateMergeTagsPathParameters,
  UpdateTouchpointVersionPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";
import { streamingMutator } from "../../config/streaming-mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getTouchpointVersion = () => {
  /**
 * Get a touchpoint version with ID

Required authority: PERM_TOUCHPOINT_READ
 */
  const getOneVersion = ({
    clientId,
    campaignId,
    touchpointId,
    id,
  }: GetOneVersionPathParameters) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}`,
      method: "GET",
    });
  };
  /**
 * Update an existing touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const updateTouchpointVersion = (
    { clientId, campaignId, touchpointId, id }: UpdateTouchpointVersionPathParameters,
    touchpointVersionDTO: TouchpointVersionDTO,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionDTO,
    });
  };
  /**
 * Delete  a touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const deleteTouchpointVersion = ({
    clientId,
    campaignId,
    touchpointId,
    id,
  }: DeleteTouchpointVersionPathParameters) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}`,
      method: "DELETE",
    });
  };
  /**
 * Partially update a Touchpoint Version

Required authority (any of): PERM_TOUCHPOINT_WRITE, PERM_CLIENT_APPROVAL
 */
  const patchTouchpointVersion = (
    { clientId, campaignId, touchpointId, id }: PatchTouchpointVersionPathParameters,
    touchpointVersionPatchRequest: TouchpointVersionPatchRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionPatchRequest,
    });
  };
  /**
 * Release lock for an existing touchpoint Version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const releaseLock = ({ clientId, campaignId, touchpointId, id }: ReleaseLockPathParameters) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/release-lock`,
      method: "PUT",
    });
  };
  /**
 * Create touchpoint version draft

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createNewDraftVersion = (
    { clientId, campaignId, touchpointId, id }: CreateNewDraftVersionPathParameters,
    touchpointVersionCreateRequest: TouchpointVersionCreateRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/create-draft`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionCreateRequest,
    });
  };
  /**
 * Claim lock for an existing touchpoint Version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const claimLock = ({ clientId, campaignId, touchpointId, id }: ClaimLockPathParameters) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/claim-lock`,
      method: "PUT",
    });
  };
  /**
 * Get all paged Touchpoint Versions

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAllVersions = (
    { clientId, campaignId, touchpointId }: GetAllVersionsPathParameters,
    params?: GetAllVersionsParams,
  ) => {
    return customInstance<PagedModelTouchpointVersionSummaryDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createTouchpointVersion = (
    { clientId, campaignId, touchpointId }: CreateTouchpointVersionPathParameters,
    touchpointVersionCreateRequest: TouchpointVersionCreateRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionCreateRequest,
    });
  };
  /**
 * Transform email content from touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const transformEmail = (
    { clientId, campaignId, touchpointId, versionId }: TransformEmailPathParameters,
    transformEmailRequest: TransformEmailRequest,
    options?: SecondParameter<typeof streamingMutator<ServerSentEventClientStreamEventDTO[]>>,
  ) => {
    return streamingMutator<ServerSentEventClientStreamEventDTO[]>(
      {
        url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${versionId}/transform-emails`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: transformEmailRequest,
      },
      options,
    );
  };
  /**
 * Transform email content from touchpoint version asynchronously via a background job

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const transformEmailAsync = (
    { clientId, campaignId, touchpointId, versionId }: TransformEmailAsyncPathParameters,
    transformEmailRequest: TransformEmailRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${versionId}/transform-emails-async`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: transformEmailRequest,
    });
  };
  /**
 * Create an email touchpoint with content in one operation

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createParentEmail = (
    { clientId, campaignId, touchpointId, versionId }: CreateParentEmailPathParameters,
    createEmailTouchpointWithContentRequest: CreateEmailTouchpointWithContentRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${versionId}/ai-parent-emails`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createEmailTouchpointWithContentRequest,
    });
  };
  /**
 * Clone touchpoint version into a new draft with merge tags updated

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const updateMergeTags = ({
    clientId,
    campaignId,
    touchpointId,
    id,
  }: UpdateMergeTagsPathParameters) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/update-merge-tags`,
      method: "POST",
    });
  };
  /**
 * Clone a touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const cloneTouchpoint = (
    { clientId, campaignId, touchpointId, id }: CloneTouchpointPathParameters,
    touchpointVersionCloneRequest: TouchpointVersionCloneRequest,
  ) => {
    return customInstance<TouchpointVersionDTO>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/clone`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionCloneRequest,
    });
  };
  /**
 * Extract links from touchpoint version final HTML

Required authority: PERM_TOUCHPOINT_READ
 */
  const extractLinksFromFinalHtml = ({
    clientId,
    campaignId,
    touchpointId,
    versionId,
  }: ExtractLinksFromFinalHtmlPathParameters) => {
    return customInstance<LinkDTO[]>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${versionId}/links`,
      method: "GET",
    });
  };
  /**
 * Returns the archived HTML content for the given touchpoint version

Required authority: PERM_TOUCHPOINT_READ
 * @summary Get archived touchpoint version HTML
 */
  const generateArchiveHtml = ({
    clientId,
    campaignId,
    touchpointId,
    id,
  }: GenerateArchiveHtmlPathParameters) => {
    return customInstance<string>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${id}/archive-content`,
      method: "GET",
    });
  };
  return {
    getOneVersion,
    updateTouchpointVersion,
    deleteTouchpointVersion,
    patchTouchpointVersion,
    releaseLock,
    createNewDraftVersion,
    claimLock,
    getAllVersions,
    createTouchpointVersion,
    transformEmail,
    transformEmailAsync,
    createParentEmail,
    updateMergeTags,
    cloneTouchpoint,
    extractLinksFromFinalHtml,
    generateArchiveHtml,
  };
};
export type GetOneVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["getOneVersion"]>>
>;
export type UpdateTouchpointVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["updateTouchpointVersion"]>>
>;
export type DeleteTouchpointVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["deleteTouchpointVersion"]>>
>;
export type PatchTouchpointVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["patchTouchpointVersion"]>>
>;
export type ReleaseLockResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["releaseLock"]>>
>;
export type CreateNewDraftVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["createNewDraftVersion"]>>
>;
export type ClaimLockResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["claimLock"]>>
>;
export type GetAllVersionsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["getAllVersions"]>>
>;
export type CreateTouchpointVersionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["createTouchpointVersion"]>>
>;
export type TransformEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["transformEmail"]>>
>;
export type TransformEmailAsyncResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["transformEmailAsync"]>>
>;
export type CreateParentEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["createParentEmail"]>>
>;
export type UpdateMergeTagsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["updateMergeTags"]>>
>;
export type CloneTouchpointResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["cloneTouchpoint"]>>
>;
export type ExtractLinksFromFinalHtmlResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["extractLinksFromFinalHtml"]>>
>;
export type GenerateArchiveHtmlResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersion>["generateArchiveHtml"]>>
>;
